/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef, useCallback } from 'react';
import useIsomorphicLayoutEffect from '../../_util/useLayoutEffect.js';
import { getScrollbarWidth } from '../../_common/js/utils/getScrollbarWidth.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_util/easing.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-92728dc5.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';

var key = 1;
function useDialogLockStyle(_ref) {
  var preventScrollThrough = _ref.preventScrollThrough,
    visible = _ref.visible,
    mode = _ref.mode,
    showInAttachedElement = _ref.showInAttachedElement;
  var lockStyleRef = useRef(document.createElement("style"));
  var timerRef = useRef(null);
  var clearStyleFunc = useCallback(function () {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(function () {
      var _lockStyleRef$current, _lockStyleRef$current2;
      (_lockStyleRef$current = lockStyleRef.current.parentNode) === null || _lockStyleRef$current === void 0 ? void 0 : (_lockStyleRef$current2 = _lockStyleRef$current.removeChild) === null || _lockStyleRef$current2 === void 0 ? void 0 : _lockStyleRef$current2.call(_lockStyleRef$current, lockStyleRef.current);
    }, 150);
  }, []);
  useIsomorphicLayoutEffect(function () {
    if (typeof document === "undefined") return;
    var hasScrollBar = document.documentElement.scrollHeight > document.documentElement.clientHeight;
    var scrollbarWidth = hasScrollBar ? getScrollbarWidth() : 0;
    lockStyleRef.current.dataset.id = "td_dialog_".concat(+new Date(), "_").concat(key += 1);
    lockStyleRef.current.innerHTML = "\n      html body {\n        overflow-y: hidden;\n        width: calc(100% - ".concat(scrollbarWidth, "px);\n      }\n    ");
    return clearStyleFunc;
  }, [clearStyleFunc]);
  useIsomorphicLayoutEffect(function () {
    if (typeof document === "undefined") return;
    if (mode !== "modal" || !preventScrollThrough || showInAttachedElement) return;
    if (visible) {
      document.head.appendChild(lockStyleRef.current);
    } else {
      clearStyleFunc();
    }
  }, [preventScrollThrough, visible, mode, showInAttachedElement, clearStyleFunc]);
}

export { useDialogLockStyle as default };
//# sourceMappingURL=useLockStyle.js.map
